import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { PermissionsService } from 'src/app/services/infra/permissionsService/permissions.service';
import { environment } from 'src/environments/environment';
import { UserLoaderGuard } from '../userLoader/user-loader.guard';

@Injectable({
  providedIn: 'root',
})
export class AdminPermissionGuard {
  constructor(
    public permissionsService: PermissionsService,
    private readonly _userLoaderGuard: UserLoaderGuard
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const hasAccess$: ReplaySubject<boolean> = new ReplaySubject(1);

    this._userLoaderGuard.canActivate(route, state).subscribe(
      (isActivated) => {
        if (isActivated) {
          const hasAccess = this.permissionsService.isAdmin();

          if (!hasAccess) {
            window.location.href = `${environment.app_base_url}/app`;
            hasAccess$.next(false);
          } else {
            hasAccess$.next(true);
          }
        } else {
          hasAccess$.next(false);
        }
      },
      (error) => {
        console.log(error);
        hasAccess$.next(false);
      }
    );

    return hasAccess$;
  }
}
